<div id="not-loggedin" class="container-fluid  main-container smrt-theme">
  <router-outlet name="master"></router-outlet>
</div>
